import styled from '@emotion/styled';
import {fonts, breakpoints} from '../../styles/vars';
import {at} from '../../styles/utils';

export const DescriptionWrapper = styled.div`
  display: ${({opened}) => (opened ? 'block' : 'none')};
  font-size: 1em;
  line-height: 1.65em;
  margin: 1em 0em 2em;
  strong {
    font-family: ${fonts.title};
  }

  ${at(breakpoints.laptop)} {
    display: ${({opened}) => (opened ? 'none' : 'block')};
  }

  ${at(breakpoints.laptop)} {
    line-height: 1.65em;
  }
`;
